module.exports = __webpack_public_path__ + "img/cooperation.0202c454.png";